export const generateAppConfig = () => {
  let exportResult = {
    appRepoLocation: "http://localhost:3000",
    backendUrl: "http://localhost:3100",
    appBackendUrl: "http://localhost:4040",
    jsReportUrl: "http://localhost:5488",
  };
  if (process.env.REACT_APP_PRODUCTION_MODE === "TEST") {
    exportResult.appRepoLocation = "https://sg-app.horizonsearesort.com.my";
    exportResult.backendUrl = "https://sg-api.horizonsearesort.com.my/admin";
    exportResult.appBackendUrl = "https://sg-api.horizonsearesort.com.my/app";
    exportResult.jsReportUrl = "https://sg-report.horizonsearesort.com.my";
  }
  if (process.env.REACT_APP_PRODUCTION_MODE === "STAGE") {
    exportResult.appRepoLocation = "https://app.travoxis.com";
    exportResult.backendUrl = "https://admin-api.travoxis.com";
    exportResult.appBackendUrl = "https://app-api.travoxis.com";
    exportResult.jsReportUrl = "https://report-test.summerbayresort.com.my";
  }
  if (process.env.REACT_APP_PRODUCTION_MODE === "PROD") {
    exportResult.appRepoLocation = "https://app.horizonsearesort.com.my";
    exportResult.backendUrl = "https://api.horizonsearesort.com.my/admin";
    exportResult.appBackendUrl = "https://api.horizonsearesort.com.my/app";
    exportResult.jsReportUrl = "https://report.horizonsearesort.com.my";
  }
  return exportResult;
};
